import React from 'react'
import Layout from '../../components/Layout'

const index = () => {
    return (
        <Layout>
            <div>
                hello from Advanced settings
            </div>
        </Layout>
    )
}

export default index
